import axios from "axios";

// export var BASE_URL = "https://safe-api.winayak.com";
// if (window.location.hostname == 'uat-safe-app.winayak.com') {
// BASE_URL = "https://uat-safe-api.winayak.com";
// }
// export var BASE_URL = "http://safehand.local";
//export var EXTERNAL_URL = "https://safe-apiv2.winayak.com/api";

/***** LOCAL *********/
//  export var BASE_URL = "http://local.sfa.in";
//  export var EXTERNAL_URL = "http://local.sfalaravel.in/api";
//  export const springMoneyUrl ="http://smallcase.safehands.in";
 //export const springMoneyUrl = "https://api-suite-uat.manthan.money";
 

/***** STAGE *********/
 //export var BASE_URL = "https://api.safehands.in";
 //export var EXTERNAL_URL = "https://auth.safehands.in/api";
 //export const springMoneyUrl ="https://smallcase.safehands.in";
/***** PROD *********/
 export var BASE_URL = "https://api.plan360degree.com";
 export var EXTERNAL_URL = "https://auth.plan360degree.com/api";
 export const springMoneyUrl = "https://springmoneyapisuite.money";
 

/********** Spring Money (Smallcase) ******************/
//export const springMoneyUrl = "https://api-suite-uat.manthan.money";

interface PropData {
  action: string;
  body?: any;
  isFormData?: boolean;
  isShowError?: boolean;
  id?: string;
}

const WebService = {
  getAccesstoken: function (props: PropData) {
    // eslint-disable-line
    // this.addLoader(props.id);
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .post(`${BASE_URL}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          localStorage.setItem("token", response.data.access_token);
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  externalgetAccesstoken: function (props: PropData) {
    // eslint-disable-line
    // this.addLoader(props.id);
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
      };
      axios
        .post(`${EXTERNAL_URL}${props.action}`, bodyFormData, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  postAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      var headers = null;
      if (props.isFormData) {
        headers = {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.getItem("token"),
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        };
        //   headers = {
        //     "Content-Type": "application/application/json",
        //     'Accept': 'application/json',
        //     Authorization: "Bearer " + localStorage.getItem("token"),
        //   };
        // } else {
        //   headers = {
        //     "Content-Type": "application/json",
        //     'Accept': 'application/json',
        //     Authorization: "Bearer " + localStorage.getItem("token"),
        //   };
      }
      axios
        .post(
          `${BASE_URL}${props.action}`,
          props.isFormData ? bodyFormData : props.body,
          {
            headers: headers,
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          // if (error && error.response && error.response.status === 401) {
          //   localStorage.clear();
          //   window.location.href = "/login";
          // }

          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },
  putAPI: function (props: PropData) {
    // eslint-disable-line
    return new Promise((resolve, reject) => {
      var bodyFormData = new URLSearchParams();
      for (let key in props.body) {
        bodyFormData.append(key, props.body[key]);
      }
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .put(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  // getAccesstoken: function (props: PropData) {
  //   // eslint-disable-line
  //   // this.addLoader(props.id);
  //   return new Promise((resolve, reject) => {
  //     var bodyFormData = new URLSearchParams();
  //     for (let key in props.body) {
  //       bodyFormData.append(key, props.body[key]);
  //     }
  //     const headers = {
  //       "Content-Type": "application/x-www-form-urlencoded",
  //     };
  //     axios
  //       .post(`${LOGIN_BASE_URL}${props.action}`, bodyFormData, {
  //         headers: headers,
  //       })
  //       .then((response) => {
  //         localStorage.setItem("token", response.data.access_token);
  //         resolve(response.data);
  //       })
  //       .catch((error) => {
  //         props.isShowError ? reject(this.errorHandler(error)) : reject(error);
  //       });
  //   });
  // },

  getAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      // let params = new URLSearchParams();
      // for (let key in props.body) {
      //   alert(key + '--' + props.body[key])
      //   params.set(key, props.body[key]);

      // }
      axios
        .get(`${BASE_URL}${props.action}`, {
          // params: params,
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  deleteAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .delete(`${BASE_URL}${props.action}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileUploadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  fileDownloadAPI: function (props: PropData) {
    return new Promise((resolve, reject) => {
      const headers = {
        "Content-Type": "multipart/form-data",
        "Content-Disposition": "attachment;filename='reports.pdf'",
        //Authorization: "Bearer " + localStorage.getItem("token"),
      };
      axios
        .post(`${BASE_URL}${props.action}`, props.body, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          props.isShowError ? reject(this.errorHandler(error)) : reject(error);
        });
    });
  },

  errorHandler: function (error: any) {
    // if (error?.response) {
    //   error = error.response;
    // }

    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "Server Not Responding";
    } else if (error.status === 401) {
      // localStorage.clear();
      // window.location.href = "/login";
    } else if (error.status === 500) {
      errorMessage =
        (error &&
          error.data &&
          error.data.ErrorDetails &&
          error.data.ErrorDetails.message) ||
        "An unkown exception has occur. Please Contact administrator";
    } else {
      errorMessage = error.data.error_description;
    }
    // toast.error(errorMessage);
    return errorMessage;
  },

  addLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = true;
        var loader = document.createElement("i");
        loader.className = "bi bi-arrow-repeat mr-2";
        button.prepend(loader);
      }
    }
  },

  removeLoader(id: any) {
    if (id) {
      var button = document.getElementById(id) as HTMLButtonElement | null;
      if (button != null) {
        button.disabled = false;
        button.removeChild(button.childNodes[0]);
      }
    }
  },
  getExternalUrl() { 
return EXTERNAL_URL; 
},
};

export default WebService;
